export default function articleReducer(state = {
    article: {},
    fetching: false,
    fetched: false
  }, action) {
    switch (action.type) {
      case 'GET_ARTICLE_PENDING': {
        return {
          ...state,
          fetching: true,
          fetched: false
        }
      }
      case 'GET_ARTICLE_FULFILLED': {
        return {
          ...state,
          fetching: false,
          fetched: true,
          article: action.payLoad.data,
          meta: action.payLoad.meta,
        }
      }
      case 'GET_ARTICLE_REJECTED': {
        return {
          ...state,
          errors: action.payLoad.errors
        }
      }
      case 'CLEAR_NEWS_ARTICLE': {
        return {
          ...state,
          article: {},
          meta: undefined
        }
      }
      default:
    }
  
    return {...state};
  }


// WEBPACK FOOTER //
// ./src/reducers/articleReducer.js